// @flow
import { get } from "common/utils/get"
import { API_ERROR } from "../../consts/api"
import { formatZoozConfirmError } from "../payments/ZoozHelper"

// eslint-disable-next-line flowtype/no-weak-types
export default function sniffError(err: any, res: any) {
  // eslint-disable-line flowtype/no-weak-types

  if (err) {
    if (get(["response", "body", "status"], err) === "error") {
      const maybeMsg = get(["response", "body", "msg"], err)
      return maybeMsg || API_ERROR
    }
    return err
  }

  const maybeError = get(["body", "status"], res)
  const status = get("status", res)

  if (status === 200 && maybeError === null) {
    return null
  }

  if (maybeError === "error") {
    if (get(["body", "code"], res) === "cannot_change_flight") {
      return get(["body", "code"], res)
    }

    if (get("body.debug.responseObject.processorError.declineReason", res)) {
      // $FlowFixMe
      const zoozErrorKey = formatZoozConfirmError(res.body.debug).key
      if (zoozErrorKey) {
        return zoozErrorKey
      }
    }

    const maybeMsg = get(["body", "msg"], res)
    return maybeMsg || API_ERROR
  }

  return null
}
